import { HTTPInstanceWithPrefix } from '@/lib/http/http-instance-with-prefix'
import {
  employeePayloadModel,
  employeeResponseModel
} from './EmployeesAPI.model'

class EmpoloyeesAPI {
  static getEmployees(): Promise<employeeResponseModel[]> {
    return HTTPInstanceWithPrefix.get('/users/?role=waiter').then(
      response => response.data
    )
  }

  // The 201 carries no body, so there is no created user to hand back, the
  // new id has to come from a re-read of the list.
  static registerEmployee(payload: employeePayloadModel): Promise<void> {
    return HTTPInstanceWithPrefix.post('/register-waiter', payload).then(
      () => undefined
    )
  }

  static updateEmployee(
    userId: string,
    payload: Partial<employeePayloadModel>
  ): Promise<employeeResponseModel> {
    return HTTPInstanceWithPrefix.put(`/users/${userId}`, payload).then(
      response => response.data
    )
  }

  static deleteEmployee(userId: string): Promise<void> {
    return HTTPInstanceWithPrefix.delete(`/users/${userId}`).then(
      response => response.data
    )
  }

  static uploadAvatar(file: File): Promise<void> {
    const formData = new FormData()
    formData.append('file', file)
    return HTTPInstanceWithPrefix.post('/users/avatar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  }
}

export default EmpoloyeesAPI
